<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Description"
                v-model="selectedLuExciseTransactionType.Description"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuExciseTransactionType.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveLuExciseTransactionTypeDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import LuExciseTransactionType from '@classes/LuExciseTransactionType'
//templateTODO: import lookup components you plan to use
export default {
  components: {
    //templateTodo: define lookup components you are using
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuExciseTransactionType: new LuExciseTransactionType(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luExciseTransactionType', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luExciseTransactionType', ['saveLuExciseTransactionType']),
    async validate() {
      this.$refs.form.validate()
    },
    editLuExciseTransactionType(entry) {
      this.selectedLuExciseTransactionType = new LuExciseTransactionType(entry)
      this.modalText = 'Edit Transaction Type'
      this.dialog = !this.dialog
    },
    addLuExciseTransactionType() {
      this.modalText = 'Insert Transaction Type'
      this.selectedLuExciseTransactionType = new LuExciseTransactionType()
      this.dialog = !this.dialog
    },
    saveLuExciseTransactionTypeDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLuExciseTransactionType(
            this.selectedLuExciseTransactionType.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLuExciseTransactionType = new LuExciseTransactionType()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuExciseTransactionType = new LuExciseTransactionType()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
